import $ from "jquery";
import pageScripts from "./pages";

//Node modules
require( "html5shiv" );
require( "promise-polyfill/dist/polyfill" );
require( "photoswipe" );

//Import plugins for seo purpose and future plugins/scripts should be added to this list
//wp_deregister_script() the script handle in /lib/setup.php and then import the file here
import '../../../../../wp/wp-includes/js/wp-embed';

require( "./components/position-chat" );
require( "./components/cookieNoticeMessage" );
require( "slick-carousel/slick/slick" );

$( document ).ready( function () {
	require( "./components/bootstrap" );
	require( "./components/mobile-nav" );
	require( "./components/sticky-navigation" );
	require( "./components/scroll-form-submit-error" );
	require( "./components/lazy-load-images" );
	require( "./components/facet-load-more" );
	require( "./components/main-search-button" );
	require( "./components/main-menu" );
	require( "./components/search-suggestions" );
	require( "./components/modal" );
	require( "./components/datepicker-restrictions" );
	require( "./datalayer/datalayer" );
	require( "./components/webshop/woocommerce-header-banner" );
	require( "./components/flexible-content/slick-slider" );
} );

if ( $( ".cta-block__button-form" ).length || $( "#saddr" ).length ) {
	import( "./components/find-nearest-store" );
}

document.body.className.replace( /-/g, "_" ).split( /\s+/ ).forEach( cls => {
	pageScripts[ cls ] && pageScripts[ cls ]();
} );
